import styled from 'styled-components'
import { grid9 } from 'shared/css/grid.css'

const Content = styled.section`
    display: flex;
    width: ${grid9};
    flex-direction: column;
`

export default Content
